<button class="btn btn-primary-outline border-0 btn-sm"
        (click)="openTerminal()">
  <fa-icon icon="terminal"></fa-icon>
</button>